import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RoleList from "../pages/Role/RoleList";
import CreateRole from "../pages/Role/CreateRole";
import EditRole from "../pages/Role/EditRole";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<RoleList />} />
          <Route path="/roles" element={<RoleList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <CreateRole />
            }
            allowedPermissions={["can_create_group"]}
            renderNoAccess={<PermissionRequired/>}
            />
          } />
          <Route path="/edit/:id" element={
               <AccessControl
               children={
                <EditRole />
               }
               allowedPermissions={["can_update_group"]}
               renderNoAccess={<PermissionRequired/>}
               />
            } />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;